"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSnackbarWrapper = exports.StyledSnackbar = exports.StyledSnackbarCloseIcon = exports.StyledSnackbarButtonBox = exports.StyledSnackbarButton = exports.StyledSnackbarTextBox = exports.StyledSnackbarText = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../general");
const utils_2 = require("./utils");
exports.StyledSnackbarText = (0, styled_components_1.default)(general_1.Typography) `
  color: ${theme_1.grayScale[50]};
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`;
exports.StyledSnackbarTextBox = (0, styled_components_1.default)(general_1.Flexbox) `
  gap: ${(0, utils_1.pxToRem)(11)};
`;
exports.StyledSnackbarButton = styled_components_1.default.button `
  border: 0;
  background-color: transparent;
  text-transform: uppercase;
  color: ${theme_1.grayScale[50]};
  font-weight: 700;
  font-size: ${(0, utils_1.pxToRem)(14)};
  transition: filter 0.3s;
  &:hover {
    filter: brightness(0.85);
  }
`;
exports.StyledSnackbarButtonBox = (0, styled_components_1.default)(general_1.Flexbox) `
  gap: ${(0, utils_1.pxToRem)(18)};
  margin: 0 2.125rem 0 2.5rem;
`;
exports.StyledSnackbarCloseIcon = (0, styled_components_1.default)(general_1.Flexbox) `
  position: absolute;
  cursor: pointer;
  & * {
    transition: filter 0.3s;
  }

  svg:hover {
    filter: brightness(0.85);
  }
`;
exports.StyledSnackbar = (0, styled_components_1.default)(general_1.Flexbox) `
  ${(props) => {
    const { variant = 'darker', block } = props;
    const isSystemVariant = variant ? variant in theme_1.system : null;
    return (0, styled_components_1.css) `
      position: relative;
      background-color: ${isSystemVariant
        ? theme_1.system[variant]
        : theme_1.primary[variant]};
      gap: ${block ? theme_1.spacings.s4 : 0};
      border-radius: 8px;
      padding: ${(0, utils_1.pxToRem)(18)};
      box-shadow: ${theme_1.shadows.default(theme_1.grayScale[900])};
      width: 100%;
      height: 100%;
      ${(0, utils_2.GetChangeSnackbarDisplay)(props)}
    `;
}}
`;
exports.StyledSnackbarWrapper = (0, styled_components_1.default)(general_1.Flexbox) `
  ${(props) => {
    const { customStyles = {} } = props;
    return (0, styled_components_1.css) `
      min-height: ${theme_1.spacings.s10};
      min-width: ${(0, utils_1.pxToRem)(352)};
      width: max-content;

      @media (max-width: 480px) {
        min-width: 335px;
        width: 85vw;
      }
      ${{ ...customStyles }}
    `;
}}
`;
//# sourceMappingURL=styles.js.map